import building from "../../icons/building.svg"
import phospor from "../../icons/Phosphor-icon.svg"
import usersLogo from "../../icons/UsersThree.svg"

const links = [
    {
        "title": "Главная",
        "path": "/",
        "iconUrl": building
    }, {
        "title": "Заявки",
        "path": "/request/list",
        "iconUrl": phospor
    },
    {
        "title": "Мои ЖК",
        "path": "/pages/buildings",
        "iconUrl": building
    },
    {
        "title": "Клиенты",
        "path": "/pages/customers",
        "iconUrl": usersLogo
    },
    {
        "title": "Объекты",
        "path": "/pages/objects",
        "iconUrl": building,
    },
];
export default links;